import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const WheatBagIntro = () => {
  const { t } = useTranslation();
  const instructionImages = [
    "/images/step1.webp",
    "/images/step2.webp",
    "/images/step3.webp",
    "/images/step4.webp",
    "/images/step5.webp",
    "/images/step6.webp",
  ];

  return (
    <div className="canvas-background bg-white pb-[2rem] md:pb-15 font-raleway overflow-x-hidden">
      <div className="container max-w-[100%] w-[100%] text-center">
        <div className="relative w-full max-w-5xl mx-auto">
          {/* The image is now the background of the relative container */}
          <img
            src="/images/cloudAsset.png"
            alt="cloud asset"
            className="w-full md:h-[14rem] h-[17rem] "
          />

          <p className="leading-1 absolute inset-0 flex items-center justify-center text-center text-[#61567a] md:text-[1.11rem] text-[1rem] md:text-xl p-[3.25rem] md:p-8 md:px-[10rem]">
            {t("wheatBagPage.wheatBagIntroPage.p1")}
          </p>
        </div>

        <div className="relative mb-0 md:mb-10">
          <img
            src="/images/wheatBagsRow.png"
            alt="Row of various wheat bags"
            className="md:w-full max-w-4xl mx-auto w-[33rem] relative right-16 md:right-0"
          />
          <img
            src="/images/lavenderSprigs.png"
            alt="Lavender sprigs"
            className="absolute md:top-0 left-0 -translate-x-[7%] -translate-y-1/4 md:w-[24rem] h-auto w-[11rem] top-[1rem]"
          />
          <img
            src="/images/brochure.webp"
            alt="Row of various wheat bags"
            className="shadow-[0_-7px_7px_-7px_rgba(0,0,0,0.3),_0_7px_7px_-7px_rgba(0,0,0,0.3)] max-w-fit md:w-full max-w-4xl mx-auto w-[40rem] relative right-[35%] md:right-0"
          />
          <img
            src="/images/wheatBagsRow2.png"
            alt="Row of various wheat bags"
            className="rotate-[1.8deg] relative md:bottom-3 md:w-full max-w-4xl mx-auto w-[33rem] bottom-[0.45rem]  right-[19%] md:right-0"
          />
          <img
            src="/images/wheatStalks.png"
            alt="Wheat stalks"
            className="absolute bottom-0 right-0 translate-x-[7%] translate-y-1/4 w-[16rem] h-auto opacity-80 hidden md:block"
          />
          {/* Call-to-Action Button */}
          <button className="text-[0.82rem] md:text-[1rem] translate-x-[-50px] translate-y-[-70px] md:translate-x-[-190%] md:translate-y-[-170%] bg-[#7eaba6] hover:bg-[#63837c] text-white font-semibold py-3.5 px-7 md:py-3 md:px-6 rounded-md shadow-lg transition duration-300 mt-6 md:mt-0">
            <a
              href="/pdfs/brochure.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("wheatBagPage.wheatBagIntroPage.buttonText")}
            </a>
          </button>
        </div>

        {/* Aromatherapy Infusion Section */}
        <div className="container max-w-[100%] w-[100%] text-center px-4 md:h-auto h-[20rem]">
          <div className="relative w-full md:max-w-[55%] max-w-[100%] mx-auto h-[20rem]">
            <img
              src="/images/cloudAsset2.png"
              alt="cloud asset"
              className="w-full md:h-[15rem] h-[17rem] "
            />
            <h3 className="absolute inset-0 md:text-[1.3rem] text-[1.1rem] font-semibold text-[#61567a] font-raleway mt-[3rem]">
              {t("wheatBagPage.wheatBagIntroPage.title")}
            </h3>
            <p className="leading-1 absolute inset-0 flex pt-[5.6rem] justify-center text-center text-[#675f77] md:text-[1.25rem] text-[0.9rem]  px-[3rem] md:px-[10rem]">
              {t("wheatBagPage.wheatBagIntroPage.p2")}
            </p>
            {/* Chamomile flowers image. Replace with your actual image path. */}
            <img
              src="/images/chamomileFlowers.png"
              alt="Chamomile flowers"
              className="md:w-[8rem] h-auto mx-auto md:translate-x-[265%] md:translate-y-[-70%] translate-x-[7rem] translate-y-[-4rem] w-20"
            />
          </div>
        </div>
      </div>

      {/* -------------------------after chamomile flowers image------------------------- */}

      <div className="container max-w-[100%] font-raleway">
        {/* Why Choose a Wheat Bag? */}
        <section className="mb-8 bg-[#6e3a56]">
          <div className="canvas-background grid grid-cols-1 md:grid-cols-5 gap-6 items-center">
            {/* Image container (right side) with a defined height and full width */}
            <div className="md:col-span-3 md:order-last h-[300px] md:h-[800px]">
              <img
                src="/images/whychoose.webp"
                alt="Sewing Scene"
                className="w-full h-full object-cover rounded-md shadow-md"
              />
            </div>

            {/* Text container (left side) taking up 2/5 of the width on medium screens and up */}
            <div className="md:col-span-2 md:pl-[6rem] text-center md:text-left pb-[2rem] md:pb-0 px-4">
              {/* The Eyebrow / Subtitle */}
              <p className="text-[#f3d8cf] uppercase tracking-[0.3em] text-xs mb-4 font-bold">
                {t("wheatBagPage.wheatBagIntroPage.section1.eyebrow")}
              </p>

              {/* Main Title */}
              <h2 className="text-3xl md:text-5xl text-white font-semibold md:mb-[3rem] mb-[1.5rem] font-playfair leading-tight">
                {t("wheatBagPage.wheatBagIntroPage.section1.title")}
              </h2>

              {/* Bullet Points with Structure */}
              <div className="text-white pr-0 md:pr-[4rem] font-raleway font-light md:text-[1.1rem] text-[0.95rem] md:space-y-10 space-y-6">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="group">
                    <h3 className="font-bold text-white mb-1 text-lg">
                      {/* Ensure this path matches the JSON perfectly */}
                      {t(
                        `wheatBagPage.wheatBagIntroPage.section1.li${i}_title`,
                      )}
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      {t(`wheatBagPage.wheatBagIntroPage.section1.li${i}_desc`)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="mb-8 bg-[#675f77]">
          <div className="canvas-background grid grid-cols-1 md:grid-cols-5 gap-6 items-center">
            <div className="md:col-span-3 h-[300px] md:h-[800px]">
              <img
                src="/images/wheatbag/machine.webp"
                alt="Wheat bag quality and maintenance"
                className="w-full h-full object-cover rounded-md shadow-md"
              />
            </div>

            <div className="md:col-span-2 md:pl-[6rem] text-center md:text-left pb-[2rem] md:pb-0 px-4">
              <p className="text-[#e9ddf3] uppercase tracking-[0.3em] text-xs mb-4 font-bold">
                {t("wheatBagPage.wheatBagIntroPage.section2.eyebrow")}
              </p>

              <h2 className="text-3xl md:text-5xl text-white font-semibold md:mb-[3rem] mb-[1.5rem] font-playfair leading-tight">
                {t("wheatBagPage.wheatBagIntroPage.section2.title")}
              </h2>

              {/* Bullet Points with Structure */}
              <div className="text-white pr-0 md:pr-[4rem] font-raleway font-light md:text-[1.1rem] text-[0.95rem] md:space-y-10 space-y-6">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="group">
                    <h3 className="font-bold text-white mb-1 text-lg">
                      {t(
                        `wheatBagPage.wheatBagIntroPage.section2.li${i}_title`,
                      )}
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      {t(`wheatBagPage.wheatBagIntroPage.section2.li${i}_desc`)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* New How To Use Section (Instruction Images) */}
        <section className="mb-10 px-4 md:px-10 font-raleway">
          <div className="rounded-2xl bg-[#fff6f1] border border-[#efd8cf] shadow-md overflow-hidden">
            {/* Header Section */}
            <div className="px-5 md:px-8 pt-6 md:pt-8 pb-4 text-center">
              <p className="text-[#8A413B] text-xs md:text-sm font-semibold uppercase tracking-[0.2em] mb-2">
                {t("wheatBagPage.howToUse.eyebrow")}
              </p>
              <h2 className="text-[#5b2e2e] text-[1.4rem] md:text-3xl font-bold mb-2">
                {t("wheatBagPage.howToUse.title")}
              </h2>
              <p className="text-[#7a5454] text-sm md:text-base max-w-3xl mx-auto">
                {t("wheatBagPage.howToUse.description")}
              </p>
            </div>

            {/* Instructions Grid */}
            <div className="px-5 md:px-8 pb-7 md:pb-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {instructionImages.map((imagePath, index) => {
                  // We use index + 1 to match the "step1, step2..." keys in your JSON
                  const stepNumber = index + 1;

                  return (
                    <div
                      key={imagePath}
                      className="rounded-xl bg-white border border-[#ecd7cf] overflow-hidden shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1"
                    >
                      <div className="relative h-[13rem] md:h-[14rem]">
                        <img
                          src={imagePath}
                          alt={t(
                            `wheatBagPage.howToUse.steps.step${stepNumber}.title`,
                          )}
                          className="absolute inset-0 w-full h-full object-cover"
                        />
                        <span className="absolute top-3 left-3 bg-[#8A413B] text-white text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
                          {t("wheatBagPage.howToUse.stepLabel", "Step")}{" "}
                          {stepNumber}
                        </span>
                      </div>

                      <div className="p-4 md:p-5 lg:text-left text-center">
                        <h3 className="text-[#5b2e2e] font-bold text-sm md:text-base">
                          {t(
                            `wheatBagPage.howToUse.steps.step${stepNumber}.title`,
                          )}
                        </h3>
                        <p className="text-[#7a5454] text-xs md:text-sm mt-2 leading-relaxed">
                          {t(
                            `wheatBagPage.howToUse.steps.step${stepNumber}.desc`,
                          )}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        {/* How to Use It */}
        <section className="">
          <div className="flex items-center justify-center relative px-[10px] lg:px-0 pt-3 pb-[1.75rem] md:pb-11">
            {/* The image on the far left */}
            <img
              src="images/lavender.png"
              alt="Lavender"
              className="w-[20%] absolute left-0 top-1/2 -translate-y-1/2 hidden md:block"
            />

            <div className="text-center">
              <h2 className="md:text-4xl text-2xl font-bold text-[#83375B] font-playfair">
                {t("wheatBagPage.therapySummary.title")}
              </h2>
              <p className="text-[#7a5454] mt-2 text-sm md:text-base">
                {t("wheatBagPage.therapySummary.subtitle")}
              </p>
            </div>
          </div>
          <div className="max-w-7xl mx-auto w-full">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8 items-stretch">
              {/* --- HEAT THERAPY CARD --- */}
              <div className="md:p-[3rem] canvas-background bg-[#f2d7d8] border border-[#f2d7d8] rounded-3xl shadow-lg p-6 flex flex-col transition-transform hover:scale-[1.02]">
                <div className="flex items-center justify-center gap-3 mb-6">
                  <h3 className="text-xl font-bold text-[#B36C5E]">
                    {t("wheatBagPage.therapySummary.heat.title")}
                  </h3>
                  <img
                    src="/images/sun.png"
                    alt="Heat"
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <ul className="text-[#8A413B] text-sm md:text-base space-y-5 flex-grow">
                  <li className="flex gap-2">
                    <span className="text-[#B36C5E]">•</span>
                    {t("wheatBagPage.therapySummary.heat.li1")}
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#B36C5E]">•</span>
                    {t("wheatBagPage.therapySummary.heat.li2")}
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#B36C5E]">•</span>
                    {t("wheatBagPage.therapySummary.heat.li3")}
                  </li>
                </ul>
              </div>

              {/* --- MIDDLE IMAGE & DOWNLOAD --- */}
              <div className="order-3 md:order-none flex flex-col items-center justify-center text-center h-full">
                <img
                  src="images/microwaveWheatBag.webp"
                  alt="Wheat Bag in Microwave"
                  className="w-full h-auto max-w-lg rounded-0 md:rounded-xl shadow-lg md:mb-6 mb-0 object-cover"
                />
                <button className="w-[100%] bg-[#df8686] hover:bg-[#b86262] text-white font-bold py-3 px-6 rounded-0 md:rounded-[5px] transition-colors transition-transform hover:scale-[1.02] shadow-md text-[0.9rem] md:text-[1rem]">
                  <a
                    href="/pdfs/instructions.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2"
                  >
                    {t("wheatBagPage.therapySummary.cta")}
                  </a>
                </button>
              </div>

              {/* --- COLD THERAPY CARD --- */}
              <div className="md:p-[3rem] canvas-background bg-[#d7e9f2] border border-[#d7e9f2] rounded-3xl shadow-lg p-6 flex flex-col transition-transform hover:scale-[1.02]">
                <div className="flex items-center justify-center gap-3 mb-6">
                  <h3 className="text-xl font-bold text-[#507FBB]">
                    {t("wheatBagPage.therapySummary.cold.title")}
                  </h3>
                  <img
                    src="/images/cold.png"
                    alt="Cold"
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <ul className="text-[#4A6D9C] text-sm md:text-base space-y-5 flex-grow">
                  <li className="flex gap-2">
                    <span className="text-[#507FBB]">•</span>
                    {t("wheatBagPage.therapySummary.cold.li1")}
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#507FBB]">•</span>
                    {t("wheatBagPage.therapySummary.cold.li2")}
                  </li>
                  <li className="flex gap-2">
                    <span className="text-[#507FBB]">•</span>
                    {t("wheatBagPage.therapySummary.cold.li3")}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Ours */}
        <section className="mt-12 mb-6 px-4 md:px-10">
          <div className="rounded-2xl bg-gradient-to-r from-[#f6ebe3] via-[#f2d7d8] to-[#e8f0f7] p-6 md:p-10 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 items-stretch">
              <div className="lg:col-span-3 text-center md:text-left">
                <p className="text-[#8A413B] font-semibold uppercase tracking-[0.2em] text-xs md:text-sm mb-2">
                  {t(
                    "wheatBagPage.whyChooseOurs.eyebrow",
                    "WHY CHOOSE CROSS BORDER WHEAT BAGS?",
                  )}
                </p>
                <h3 className="text-[#5b2e2e] text-2xl md:text-4xl font-bold mb-4">
                  {t(
                    "wheatBagPage.whyChooseOurs.title",
                    "A Premium Alternative to Generic Heat Packs",
                  )}
                </h3>
                <p className="text-[#6e4a4a] text-sm md:text-base mb-6 max-w-2xl mx-auto md:mx-0">
                  {t(
                    "wheatBagPage.whyChooseOurs.description",
                    "Handcrafted with a focus on durability, comfort, and consistent temperature control. Here is why our weighted wheat bags stand apart.",
                  )}
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                  <div className="bg-white/80 rounded-xl p-4 border border-[#e8c9c0] transition-transform hover:scale-[1.02] text-center md:text-left">
                    <p className="text-[#8A413B] font-semibold mb-1">
                      {t(
                        "wheatBagPage.whyChooseOurs.card1.title",
                        "Meticulously Handcrafted",
                      )}
                    </p>
                    <p className="text-[#6e4a4a] text-sm">
                      {t(
                        "wheatBagPage.whyChooseOurs.card1.description",
                        "Unlike factory-made packs, each bag is hand-finished using 100% natural cotton, ensuring reinforced seams that prevent leaks and last for years.",
                      )}
                    </p>
                  </div>

                  <div className="bg-white/80 rounded-xl p-4 border border-[#e8c9c0] transition-transform hover:scale-[1.02] text-center md:text-left">
                    <p className="text-[#8A413B] font-semibold mb-1">
                      {t(
                        "wheatBagPage.whyChooseOurs.card2.title",
                        "Targeted 1kg Weighted Relief",
                      )}
                    </p>
                    <p className="text-[#6e4a4a] text-sm">
                      {t(
                        "wheatBagPage.whyChooseOurs.card2.description",
                        "At 46cm x 13cm and 1kg in weight, our bags are specifically engineered to stay in place on your neck, shoulders, or waist for deeper pressure therapy.",
                      )}
                    </p>
                  </div>

                  <div className="bg-white/80 rounded-xl p-4 border border-[#c9dceb] transition-transform hover:scale-[1.02] text-center md:text-left">
                    <p className="text-[#2b5f86] font-semibold mb-1">
                      {t(
                        "wheatBagPage.whyChooseOurs.card3.title",
                        "Longer heat retention",
                      )}
                    </p>
                    <p className="text-[#425b6d] text-sm">
                      {t(
                        "wheatBagPage.whyChooseOurs.card3.description",
                        "We use strictly selected, locally sourced wheat grains that hold thermal energy longer than generic fillers, providing up to 50 minutes of soothing relief.",
                      )}
                    </p>
                  </div>

                  <div className="bg-white/80 rounded-xl p-4 border border-[#c9dceb] transition-transform hover:scale-[1.02] text-center md:text-left">
                    <p className="text-[#2b5f86] font-semibold mb-1">
                      {t(
                        "wheatBagPage.whyChooseOurs.card4.title",
                        "Aromatherapy for the Soul",
                      )}
                    </p>
                    <p className="text-[#425b6d] text-sm">
                      {t(
                        "wheatBagPage.whyChooseOurs.card4.description",
                        "Our bags feature high-quality lavender that releases a calming scent when warmed, helping to reduce anxiety and deepen your relaxation during every use.",
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2 h-full">
                <div className="relative h-full min-h-[260px] rounded-xl border-2 border-dashed border-[#c7a79d] bg-white/60 overflow-hidden">
                  <img
                    src="/images/premium.webp"
                    alt="Sewing machine and wheat bag details"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Kids Edition Spotlight Banner ─────────────────────────────── */}
        <section className="mb-12 bg-[#2d5348]">
          <div className="canvas-background grid grid-cols-1 md:grid-cols-5 gap-6 items-center">
            <div className="md:col-span-3 md:order-last h-[300px] md:h-[800px]">
              <img
                src="/images/wheatbag-kids/wk1.webp"
                alt="Cross Border Kids Edition"
                className="w-full h-full object-cover rounded-md shadow-md"
              />
            </div>

            <div className="md:col-span-2 md:pl-[6rem] text-center md:text-left pb-[2rem] md:pb-0 px-4">
              <p className="text-[#c8ede7] uppercase tracking-[0.3em] text-xs mb-4 font-bold">
                {t(
                  "wheatBagPage.kidsEdition.eyebrow",
                  "Specially for little ones",
                )}
              </p>
              <h2 className="text-3xl md:text-5xl text-white font-semibold md:mb-[2.5rem] mb-[1.5rem] font-playfair leading-tight">
                {t("wheatBagPage.kidsEdition.title", "The Kids Edition")}
              </h2>

              <div className="text-white font-raleway font-light md:text-[1.05rem] text-[0.9rem] md:space-y-8 space-y-5">
                <div className="text-center md:text-left">
                  <h3 className="font-bold text-white mb-1 text-lg">
                    {t(
                      "wheatBagPage.kidsEdition.feature1.title",
                      "Fragrance-Free & Extra Gentle",
                    )}
                  </h3>
                  <p className="text-white/80 leading-relaxed">
                    {t(
                      "wheatBagPage.kidsEdition.feature1.description",
                      "Designed without lavender or essential oils to ensure a soothing experience that is never overwhelming or irritating for sensitive children.",
                    )}
                  </p>
                </div>

                <div className="text-center md:text-left">
                  <h3 className="font-bold text-white mb-1 text-lg">
                    {t(
                      "wheatBagPage.kidsEdition.feature2.title",
                      "Perfectly Sized for Tiny Tummies",
                    )}
                  </h3>
                  <p className="text-white/80 leading-relaxed">
                    {t(
                      "wheatBagPage.kidsEdition.feature2.description",
                      "At a compact 17x20 cm, this edition is lighter and easier for small hands to hold-offering the perfect weight for soothing relief.",
                    )}
                  </p>
                </div>

                <div className="text-center md:text-left">
                  <h3 className="font-bold text-white mb-1 text-lg">
                    {t(
                      "wheatBagPage.kidsEdition.feature3.title",
                      "Hygienic Washable Outer Cover",
                    )}
                  </h3>
                  <p className="text-white/80 leading-relaxed">
                    {t(
                      "wheatBagPage.kidsEdition.feature3.description",
                      "Because life with kids can be messy, the high-quality outer cover is completely removable and machine washable for effortless care.",
                    )}
                  </p>
                </div>

                <div className="text-center md:text-left">
                  <h3 className="font-bold text-white mb-1 text-lg">
                    {t(
                      "wheatBagPage.kidsEdition.feature4.title",
                      "Portable & Perfectly Sized",
                    )}
                  </h3>
                  <p className="text-white/80 leading-relaxed">
                    {t(
                      "wheatBagPage.kidsEdition.feature4.description",
                      "At a compact 17x20 cm, this edition is designed to be travel-friendly. It fits easily into diaper bags or strollers, providing natural comfort wherever your adventures take you.",
                    )}
                  </p>
                </div>

                {/* --- NEW ADDED SECTION: BEST FOR TAGS --- */}
                <div className="pt-4">
                  <p className="text-[#c8ede7] text-[0.75rem] uppercase tracking-widest mb-4 font-bold opacity-90">
                    {t(
                      "wheatBagPage.kidsEdition.tagsLabel",
                      "Natural relief for:",
                    )}
                  </p>
                  <div className="flex flex-wrap justify-center md:justify-start gap-2">
                    {[
                      "wheatBagPage.kidsEdition.tags.tummyAches",
                      "wheatBagPage.kidsEdition.tags.growingPains",
                      "wheatBagPage.kidsEdition.tags.bedtimeComfort",
                      "wheatBagPage.kidsEdition.tags.coldCompresses",
                    ].map((tagKey) => (
                      <span
                        key={tagKey}
                        className="bg-[#d3ffc21f] px-3 py-1 rounded-full border border-white/20 bg-white/5 text-white text-[0.7rem] font-medium tracking-wide transition-transform hover:scale-[1.02]"
                      >
                        {t(tagKey)}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Editions Comparison Grid ──────────────────────────────────── */}
        <section className=" my-5 px-4 md:px-10">
          <div className="text-center mb-8">
            <p className="text-[#6e4a4a] uppercase tracking-[0.2em] text-xs font-bold mb-2">
              {t(
                "wheatBagPage.editionsComparison.eyebrow",
                "Find Your Perfect Match",
              )}
            </p>
            <h2 className="text-[#3a2020] text-2xl md:text-4xl font-bold font-playfair">
              {t(
                "wheatBagPage.editionsComparison.title",
                "Choose Your Edition",
              )}
            </h2>
            <p className="text-[#7a5454] text-sm md:text-base mt-2 max-w-xl mx-auto">
              {t(
                "wheatBagPage.editionsComparison.description",
                "Both handmade with care. Each designed for a different need.",
              )}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Standard Edition card */}
            <Link
              to="/product/wheatbag-fox-mint"
              className="rounded-2xl overflow-hidden shadow-lg border border-[#e8c9c0] flex flex-col transition-transform hover:scale-[1.02] cursor-pointer"
            >
              <div className="h-[220px] md:h-[350px] relative">
                <img
                  src="/images/wheatbag/yellow5.webp"
                  alt="Standard wheat bag edition"
                  className="absolute inset-0 w-full h-full object-cover "
                />
                <span className="absolute top-4 left-4 bg-[#6e3a56] text-white text-xs font-bold px-4 py-1.5 rounded-full tracking-wide uppercase">
                  {t(
                    "wheatBagPage.editionsComparison.standard.badge",
                    "Standard Edition",
                  )}
                </span>
              </div>
              <div className="bg-[#fdf5f8] p-6 flex flex-col gap-3 flex-grow">
                <h3 className="text-[#5b2e2e] text-xl font-bold font-playfair">
                  {t(
                    "wheatBagPage.editionsComparison.standard.title",
                    "Classic Wheat Bag",
                  )}
                </h3>
                <p className="text-[#7a5454] text-sm leading-relaxed">
                  {t(
                    "wheatBagPage.editionsComparison.standard.description",
                    "Full-sized, lavender-infused wheat bag for adults. Designed for deep muscle relief, neck, shoulder, and back comfort.",
                  )}
                </p>
                <ul className="mt-2 space-y-2 text-sm text-[#6e4a4a]">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="text-[#6e3a56] font-bold mt-0.5">✓</span>
                      {t(
                        `wheatBagPage.editionsComparison.standard.points.p${i}`,
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </Link>

            {/* Kids Edition card */}
            <Link
              to="/product/wheatbag-kids-fox-mint"
              className="rounded-2xl overflow-hidden shadow-lg border border-[#b8dcd5] flex flex-col transition-transform hover:scale-[1.02] cursor-pointer"
            >
              <div className="h-[220px] md:h-[350px] relative">
                <img
                  src="/images/wheatbag-kids/wk20.webp"
                  alt="Kids wheat bag edition"
                  className="absolute inset-0 w-full h-full object-cover object-[50%_10%]"
                />
                <span className="absolute top-4 left-4 bg-[#4a7c6e] text-white text-xs font-bold px-4 py-1.5 rounded-full tracking-wide uppercase">
                  {t(
                    "wheatBagPage.editionsComparison.kids.badge",
                    "Kids Edition",
                  )}
                </span>
              </div>
              <div className="bg-[#f2faf8] p-6 flex flex-col gap-3 flex-grow">
                <h3 className="text-[#1e3d38] text-xl font-bold font-playfair">
                  {t(
                    "wheatBagPage.editionsComparison.kids.title",
                    "Kids Wheat Bag",
                  )}
                </h3>
                <p className="text-[#3a6058] text-sm leading-relaxed">
                  {t(
                    "wheatBagPage.editionsComparison.kids.description",
                    "Smaller, lighter, and scent-free. Built for children's delicate comfort with a washable outer cover for hygienic, easy maintenance.",
                  )}
                </p>
                <ul className="mt-2 space-y-2 text-sm text-[#2e5a52]">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="text-[#4a7c6e] font-bold mt-0.5">✓</span>
                      {t(`wheatBagPage.editionsComparison.kids.points.p${i}`)}
                    </li>
                  ))}
                </ul>
              </div>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WheatBagIntro;
